const LAPTOP = 1112;
const TABLET = 1024;
const MOBILE = 768;

export { LAPTOP, TABLET, MOBILE };
